
// sections
// mock
import { useLayoutEffect, useState } from "react";
import { useAuth } from "src/hooks/useAuth";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Shoppers from "./SuperAdminComponent/Shoppers";
import ShopOwners from "./SuperAdminComponent/ShopOwners";
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------



export default function BrandOwner() {
  const {data} = useAuth();
  const [value, setValue] = useState('1');

  


  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  



  useLayoutEffect(() => () => {
    localStorage.removeItem('ptvs')
  }, [])
  
  


  

  return   (
    <>
      <div className="wrapper  mt-4 mt-md-1 px-2">
        <div   className="header d-block d-md-none mb-4">
          <h4 className={`mb-0 pb-0`}>Sales</h4>
          
          <p style={{fontSize: '14px'}} className={`mb-0 pb-0`}>
          An overview of your sales performance
        

          </p>

        </div>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Shoppers />
          </Box>
        {/* <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs ">
                <Tab label="Merchants" value="1" />
                <Tab label="Shoppers" value="1" />
              </TabList>
            </Box>
            <TabPanel value="1"  style={{padding: '0'}}>
              <ShopOwners key={1} />
            </TabPanel>
            <TabPanel value="1" style={{padding: '0'}}>
              <Shoppers key={2} />
            </TabPanel>
          </TabContext> */}
        

      </div>
     
    </>
  ) 
}
